import { Grid, Typography, Card, CardContent, TextField } from '@mui/material';
import { COLOR_BLACK_PERL } from '../../popTheme';
import { useEffect, useState } from 'react';
import { sendUpdateQuestionnaireResponse } from '../../redux/sagas/updateQuestionnaireResponseSaga';
import { useDispatch } from 'react-redux';

export const NotesCard = ({ title, background, placeholder, questionnaireResponse }) => {
  const [editing, setEditing] = useState(false);
  const dispatch = useDispatch();

  const content = questionnaireResponse?.extension?.[0].valueCode || '';
  const [note, setNote] = useState(content);

  const handleEdit = () => {
    setEditing(true);
  };

  const handleChange = (e) => {
    setNote(e.target.value);
  };
  const handleSave = (e) => {
    setEditing(false);
    const newContent = e.target.value;
    if (newContent !== content) {
      dispatch(
        sendUpdateQuestionnaireResponse({
          id: questionnaireResponse.id,
          authored: questionnaireResponse.authored,
          extension:
            newContent !== ''
              ? [
                  {
                    url:
                      questionnaireResponse.extension?.[0].url ||
                      'http://hl7.org/fhir/StructureDefinition/iso-21090-name-use',
                    valueCode: newContent,
                  },
                ]
              : [],
          item: questionnaireResponse.item,
          questionnaire: questionnaireResponse.questionnaire,
          status: questionnaireResponse.status,
          subject: questionnaireResponse.subject,
          resourceType: questionnaireResponse.resourceType,
        }),
      );
    }
  };

  useEffect(() => {
    setNote(content);
  }, [questionnaireResponse]);

  return (
    <Card
      sx={{
        padding: '1.25rem',
        minHeight: { xs: '28rem', md: '25.25rem' },
        minWidth: '20.5rem',
        width: 'auto',
        borderRadius: '0.75rem',
        background,
      }}
    >
      <CardContent>
        <Grid container>
          <Grid
            container
            justifyContent={'space-between'}
            borderBottom={1}
            borderColor={COLOR_BLACK_PERL}
            paddingBottom={'1.25rem'}
          >
            <Typography variant="h5" color={COLOR_BLACK_PERL}>
              {title}
            </Typography>
          </Grid>
          <Grid
            overflow={'auto'}
            sx={{
              height: { xs: '23rem', md: '19rem' },
              width: '100%',
              mt: '1rem',
              '&::-webkit-scrollbar': {
                width: 7,
              },
              '&::-webkit-scrollbar-track': {
                boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: COLOR_BLACK_PERL,
                outline: `0.5px solid slategrey`,
              },
            }}
          >
            {(editing && (
              <TextField
                value={editing ? note : (note === '' && placeholder) || note}
                onChange={(e) => {
                  handleChange(e);
                }}
                onBlur={(e) => {
                  handleSave(e);
                }}
                multiline
                rows={9}
                inputProps={{
                  maxLength: 1000,
                  style: {
                    overflow: 'hidden',
                    color: COLOR_BLACK_PERL,
                    lineHeight: '175%',
                  },
                }}
                sx={{
                  width: '100%',
                  whiteSpace: 'pre-wrap',
                }}
              />
            )) || (
              <Typography
                variant="body"
                contentEditable
                suppressContentEditableWarning
                gutterBottom
                onFocus={handleEdit}
                color={COLOR_BLACK_PERL}
                sx={{
                  lineHeight: '175%',
                  outline: `0 solid transparent`,
                  whiteSpace: 'pre-wrap',
                }}
              >
                {(note === '' && placeholder) || note}
              </Typography>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
